import { Text } from "../../components/Forms/InputButton/styles";
import { ObservationIcon } from "../../styles/icons/ObservationIcon";
import { Divider, Header, Section, TextArea } from "./styles";

interface ObservationSectionProps {
  register: any;
  errors: any;
  watch: any;
  observation?: string;
  asPreview?: any;
  asModalConfirmation?: boolean;
}

export function ObservationSection({
  register,
  errors,
  watch,
  asPreview,
  observation,
  asModalConfirmation = false
}: ObservationSectionProps) {
  return (
    <>
      <Section flexDir="column">
        <Section gap=".4rem">
          <ObservationIcon />
          <Header>Observações</Header>
        </Section>
        <Section flexDir="column" gap="0.1rem">
          {!asPreview && (
            <TextArea
              placeholder="Insira aqui a observação sobre as alterações"
              borderColor={errors ? "var(--red-700)" : "#C3CAD7"}
              name="observation"
              {...register("observation")}
              errors={errors}
            />
          )}
          {asPreview && (
            <Text fontSize=".8rem">
              {observation}
            </Text>
          )}
          {errors && (
            <Text color="var(--red-600)" fontSize=".8rem">
              {errors?.message}
            </Text>
          )}
        </Section>
        {asModalConfirmation && (
          <Divider />
        )}
        {!asPreview && (
          <Divider />
        )}
      </Section>
    </>
  )
}